export const purchaseUrls = {
  stretching: 'https://www.compradigitalya.com/cart/42953260892231:1',
  complete: 'https://www.compradigitalya.com/cart/42953261252679:1',
}

export const testimonials = [
  {
    initials: 'VR',
    name: 'Valeria R.',
    place: 'Córdoba, Argentina · 32 años · Instructora de stretching',
    text: 'La verdad que no esperaba tanto. Lo compré un domingo a la noche y el lunes ya di la clase con el Tomo 1. Mis alumnas notaron la diferencia: la clase tuvo un orden que antes me llevaba horas armar. Yo también terminé mucho más tranquila.',
  },
  {
    initials: 'CM',
    name: 'Carolina M.',
    place: 'La Plata, Argentina · 38 años · Profesora de Educación Física',
    text: 'Tenía un alumno con hernia y me quedé en blanco. Con el Tomo 4 encontré cómo abordar la clase y cuándo frenar. Ahora tengo un criterio claro, no improviso y eso se nota muchísimo en la confianza de mis alumnos.',
  },
  {
    initials: 'JP',
    name: 'Jimena P.',
    place: 'Rosario, Argentina · 29 años · Instructora de pilates y stretching',
    text: 'Antes perdía horas buscando ejercicios en internet y al final nada cerraba bien. Ahora abro el tomo que necesito, adapto la clase al grupo y listo. Me devolvió tiempo y mis alumnas sienten que cada semana avanzan.',
  },
  {
    initials: 'LT',
    name: 'Luciana T.',
    place: 'Mendoza, Argentina · 41 años · Profesora de actividad física',
    text: 'Me sirvió muchísimo el tema de los precios. Cobraba barato porque no sabía explicar todo el trabajo que había detrás. Con el sistema ordené mi propuesta, subí las tarifas y no perdí ninguna alumna.',
  },
  {
    initials: 'DS',
    name: 'Diego S.',
    place: 'Mar del Plata, Argentina · 35 años · Entrenador personal',
    text: 'Trabajo con grupos mixtos y esa era mi mayor dificultad. El kit de adaptaciones me cambió la dinámica: hoy todos hacen la misma clase con una variante que les sirve de verdad. Me siento mucho más profesional.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Nivel Principiante',
    period: 'Base Sólida',
    content: [
      '8 clases completas listas para usar desde el día uno',
      'Fundamentos del stretching 2026 con base científica',
      'Anatomía básica del movimiento y 7 principios del stretching seguro',
      'Progresión de 4 semanas, fichas imprimibles y checklist del profesor',
      'Tips de comunicación con principiantes',
    ],
  },
  {
    icon: '📗',
    name: 'Nivel Intermedio',
    period: 'Semanas 5 a 16',
    content: [
      '10 clases con técnica FNP incluida',
      'Stretching con banda elástica y palo',
      'Flujos dinámicos intermedios',
      'Progresión de 8 semanas y fichas de seguimiento del alumno',
    ],
  },
  {
    icon: '📙',
    name: 'Nivel Avanzado',
    period: 'Semanas 17 a 32',
    content: [
      '10 clases de elite incluyendo split sagital y lateral',
      'Técnicas isométricas avanzadas',
      'Stretching deportivo para runners, artes marciales y danza',
      'Yoga avanzado integrado y progresión de 12 semanas',
    ],
  },
  {
    icon: '📕',
    name: 'Stretching Terapéutico',
    period: 'Protocolos Clínicos',
    content: [
      '10 protocolos para las patologías más comunes',
      'Lumbalgia, cervicalgia, ciática, fibromialgia y síndrome postural digital',
      'Marco legal y ético del instructor',
      'Fichas de evaluación clínica incluidas',
    ],
  },
  {
    icon: '📓',
    name: 'Planificador Anual + Sistema de Negocio',
    period: 'Tu Negocio Organizado',
    content: [
      '52 semanas de clases organizadas',
      'Sistema de precios Argentina 2026',
      'Marketing digital para profes y modelo corporativo para empresas',
      'Templates, contratos, consentimientos y sistema de certificación',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '📋',
    'Entradas en Calor Inteligentes',
    '30 secuencias listas para usar. Una entrada en calor para cada ocasión y nivel, con tabla rápida de selección incluida.',
    '$12.000',
  ],
  [
    '02',
    '💬',
    'Banco de Frases Profesionales',
    '250+ frases listas para guiar, corregir sin incomodar y acompañar a alumnos que se frustran.',
    '$10.000',
  ],
  [
    '03',
    '📊',
    'Fichas de Evaluación y Progreso',
    '5 tests de evaluación funcional, registro semanal y mensual, más reportes profesionales para entregar.',
    '$12.000',
  ],
  [
    '04',
    '🎭',
    'Clases Temáticas Express',
    '20 clases temáticas listas para usar, 60 nombres vendibles y plan de contenido para redes incluido.',
    '$14.000',
  ],
  [
    '05',
    '🔄',
    'Kit de Adaptaciones para Grupos Mixtos',
    '50 ejercicios con 150 variantes, guía de silla, pared y banda, más 40 situaciones reales resueltas.',
    '$12.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si recién empiezo a trabajar con stretching?',
    'Sí. El Tomo 1 te da toda la base científica y práctica que necesitás antes de tu primera clase. Podés empezar desde cero y dar clases profesionales desde el primer día.',
  ],
  [
    '¿Cómo recibo el material?',
    'Inmediatamente después de tu pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo el sistema en tu dispositivo. Funciona en celular, tablet y computadora.',
  ],
  [
    '¿Puedo usarlo si ya tengo alumnos en nivel intermedio o avanzado?',
    'Sí. El sistema tiene niveles distintos. Podés entrar por el tomo que corresponde a tus alumnos actuales y usar el resto para los próximos grupos.',
  ],
  [
    '¿La garantía es real?',
    '100% real. Si en 7 días no estás satisfecho, escribís a compradigitalyaa@gmail.com y te devolvemos el dinero sin preguntas ni formularios.',
  ],
  [
    '¿Funciona para clases grupales e individuales?',
    'Sí. Todo el sistema está diseñado para ambos formatos. El Tomo 5 incluye un modelo de precios y organización para clases grupales, semi-privadas e individuales.',
  ],
  [
    '¿Qué pasa si tengo un alumno con una patología específica?',
    'El Tomo 4 tiene 10 protocolos terapéuticos para las patologías más comunes. El Bono 5 agrega adaptaciones para 50 ejercicios con tres versiones cada uno.',
  ],
] as const

export const moreTestimonials = [
  {
    initials: 'RA',
    name: 'Roberto A.',
    place: 'Buenos Aires · Profesor de Educación Física',
    text: 'Una vez me anotaron un señor de 70 años y no supe ni por dónde arrancar. Con el sistema senior ahora tengo todo armado y me recomienda con todos sus amigos.',
  },
  {
    initials: 'MF',
    name: 'Melina F.',
    place: 'Córdoba · Instructora de stretching',
    text: 'Este lo abrí el sábado a la noche y el lunes di la mejor clase que di en meses. Mis alumnas me preguntaron qué había cambiado.',
  },
  {
    initials: 'NG',
    name: 'Natalia G.',
    place: 'Rosario · Profesora de actividad física',
    text: 'Las fichas de evaluación cambiaron todo. Una alumna me dijo que nunca ningún profe le había entregado un reporte mensual.',
  },
  {
    initials: 'FM',
    name: 'Florencia M.',
    place: 'Mendoza · Instructora independiente',
    text: 'Leí el Tomo 5, subí los precios un 40% y no perdí ninguna alumna. Al contrario, empezaron a verme diferente.',
  },
  {
    initials: 'AL',
    name: 'Andrea L.',
    place: 'Santa Fe · Profesora de Educación Física',
    text: 'Con el Tomo 4 encontré el protocolo exacto para una alumna con ciática. A las dos semanas me dijo que hacía meses que no sentía tanto alivio.',
  },
  {
    initials: 'RC',
    name: 'Romina C.',
    place: 'La Plata · Instructora de stretching y yoga',
    text: 'El banco de frases cambió mucho mis clases. Los alumnos se relajan más rápido y yo me siento mucho más segura hablando.',
  },
]
